import RichTextEditorFieldWithFileUpload from './RichTextEditorFieldWithFileUpload.component';

export default RichTextEditorFieldWithFileUpload;